import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@bt/shared';
import { NgSelectizeModule } from 'ng-selectize';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { JobParametersModalComponent } from "./job-parameters-component";
import { CoinPurchaseInfoService } from "@bt/auto-coin-purchase/services/coinPurchaseInfo.service";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    NgSelectizeModule,
    FontAwesomeModule,
  ],
  entryComponents: [],
  providers: [CoinPurchaseInfoService],
  declarations: [
    JobParametersModalComponent,
  ],
})

export class JobParametersModalModule {
}



// WEBPACK FOOTER //
// ./src/app/auto-coin-purchase/job-parameters/job-parameters-component.module.ts